import React, { useState } from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { VideoDisplay } from "./VideoDisplay";
import { WizardStyledBoxContainer } from "@/styles/theme";

interface FieldLayoutProps {
  label: string;
  description?: string;
  children: React.ReactNode;
  error?: boolean;
  helperText?: string;
  videoUrl?: string;
}

export const FieldLayout: React.FC<FieldLayoutProps> = ({
  label,
  description,
  children,
  error,
  helperText,
  videoUrl,
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => {
    setExpanded(!expanded);
  };

  return (
    // Fundo transparente: o WizardStyledBoxContainer nasce ESCURO (tema MUI, desenhado
    // para a pagina escura original), mas o card do formulario hoje e branco com texto
    // escuro herdado. Escuro sobre escuro deixava o rotulo do campo ilegivel — o cliente
    // via "Selecionar Arquivo" sem conseguir ler QUAL documento enviar. Transparente faz
    // o conteudo sentar no card branco e herdar a cor certa.
    <WizardStyledBoxContainer sx={{ mb: 2, backgroundColor: "transparent" }}>
      <Typography variant="h6">{label}</Typography>
      {description && <Typography>{description}</Typography>}
      {videoUrl && (
        <Accordion expanded={expanded} onChange={handleChange}>
          {/* Sem cor fixa: estava travado em #FFF, que sumiria agora que o campo
              senta no card branco. "inherit" segue a cor do card. */}
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "inherit" }} />}>
            <Typography>Vídeo Explicativo</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {videoUrl && (
              <WizardStyledBoxContainer>
                <VideoDisplay url={videoUrl} sx={{ width: "100%" }} />
              </WizardStyledBoxContainer>
            )}
          </AccordionDetails>
        </Accordion>)}
      {children}

      {error && helperText && (
        <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
          {helperText}
        </Typography>
      )}
    </WizardStyledBoxContainer>);

};
